import { Context } from '@vue-storefront/core';
import { computed } from '@nuxtjs/composition-api';

// Expiry of cookie to 9 days and 23 hours as shopify cart cookies expire in 10 days.
const CART_COOKIE_EXPIRY = 60 * 60 * 24 * 8;

const CART_ID = '_cart_id_v2';

const useCartStorage = (context: Context) => {
  const cartIdCookieName = computed(() => {
    return `${context.$shopify.config.app.$config.appIdentifier}${CART_ID}`;
  });

  const getCartIdFromStorage = (): string | null => {
    return context.$shopify.config.app.$cookies.get(cartIdCookieName.value);
  };

  const saveCartIdToStorage = (cartId: string) => {
    context.$shopify.config.app.$cookies.set(cartIdCookieName.value, cartId, {
      maxAge: CART_COOKIE_EXPIRY,
      path: '/',
    });
  };

  const removeCartIdFromStorage = () => {
    context.$shopify.config.app.$cookies.remove(cartIdCookieName.value);
  };

  return {
    getCartIdFromStorage,
    saveCartIdToStorage,
    removeCartIdFromStorage,
  };
};

export default useCartStorage;
